<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    icon?: string;
    label?: string;
    value?: string;

    tonal?: boolean;
  }>(),
  {}
);

const { nl2br, striptags } = useHelper();

const { currentPalette } = useTheme();
</script>

<template>
  <div class="post-content-project-data">
    <div class="post-content-project-data__wrapper">
      <div
        v-if="props.icon || $slots['icon']"
        class="post-content-project-data__icon text-center flex items-center justify-center mb-1"
      >
        <slot name="icon" v-bind="{ props }">
          <Icon v-if="props.icon" :name="props.icon" class="w-6 h-6" />
        </slot>
      </div>

      <div
        v-if="props.label || $slots['label']"
        class="post-content-project-data__label text-center mt-1 mb-2"
      >
        <h4 class="text-xs leading-[0.875rem]">
          <slot name="label" v-bind="{ props }">
            <span
              v-if="props.label"
              v-html="nl2br(striptags(props.label))"
            ></span>
          </slot>
        </h4>
      </div>

      <div
        v-if="props.value || $slots['value']"
        class="post-content-project-data__value text-center mt-2"
      >
        <p
          class="font-bold text-sm leading-[0.875rem]"
          :class="[{ [currentPalette.text]: tonal }]"
        >
          <slot name="value" v-bind="{ props }">
            {{ props.value }}
          </slot>
        </p>
      </div>
    </div>
  </div>
</template>
